import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { FetchCategories, AddTotalCount, AddError, GetCategory } from './category.action';
import { Observable } from 'rxjs';
import { Category } from '../../models/category';
import * as selector from './category.selector';
import { CategoryState } from './category.state';
import { CategoryPagination } from '@modules/category/models/category-pagination';
import { CategoryFilter } from '@modules/category/models/category-filter';

@Injectable()
export class CategoryStoreService {
  constructor(private store: Store<CategoryState>) {}

  public fetchAllCategories(
    categoryPagination: CategoryPagination,
    categoryFilter: CategoryFilter,
  ): void {
    this.store.dispatch(FetchCategories({categoryPagination, categoryFilter}));
  }

  public getAllCategories(): Observable<Category[]> {
    return this.store.pipe(select(selector.getAllCategories));
  }

  public getCategoryById(id: string): Observable<Category> {
    return this.store.select(selector.getCategoryById(id));
  }

  public addCategoryTotalCount(data: number): void {
    this.store.dispatch(AddTotalCount({ totalCount: data }));
  }

  public getCategoryTotalCount(): Observable<number> {
    return this.store.select(selector.getTotalCount);
  }

  public loadError(error: any): void {
    this.store.dispatch(AddError(error));
  }

  public fetchCategoryById(id: string): void {
    this.store.dispatch(GetCategory({ id: id }));
  }
}
